const PERIOD_ORDER = { warmup: 0, workout: 1, cooldown: 2 };

function formatWorkoutPeriodLabel(title, description) {
  if (description?.trim()) return description.trim();
  const key = (title || '').toLowerCase();
  if (key === 'warmup') return 'Warm Up';
  if (key === 'workout') return 'Workout';
  if (key === 'cooldown') return 'Cool Down';
  if (!title) return 'Period';
  return title.charAt(0).toUpperCase() + title.slice(1);
}

/** Periods derived from workout_common_utils.workout_group_types (source of truth). */
export function getWorkoutPeriods(workoutGroupTypes = []) {
  return [...workoutGroupTypes]
    .filter((g) => g?.id)
    .sort((a, b) => {
      const ak = (a.title || '').toLowerCase();
      const bk = (b.title || '').toLowerCase();
      return (PERIOD_ORDER[ak] ?? 99) - (PERIOD_ORDER[bk] ?? 99);
    })
    .map((g) => {
      const key = (g.title || '').toLowerCase();
      return {
        key,
        label: formatWorkoutPeriodLabel(g.title, g.description),
        groupTypeId: g.id,
      };
    });
}

export function findWorkoutGroupType(workoutGroupTypes, periodKey) {
  return workoutGroupTypes.find(
    (g) => (g.title || '').toLowerCase() === (periodKey || '').toLowerCase()
  );
}
